import { c as _c } from "react/compiler-runtime";
import useSuspenseQuery from 'commons/useSuspenseQuery';
import { GET_PRODUCTS_STATIC_DATA } from 'mocks/queries';
import useIsRefreshCache from 'hooks/useIsRefreshCache';
import getVisitorLocationQueryVariables from 'commons/getVisitorLocationQueryVariables';
import useUserLocation from 'global-state/userLocation/useUserLocation';
const useStaticProductsData = (t0, t1) => {
  const $ = _c(20);
  const {
    productIds
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? {} : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const {
    skip: t3
  } = t2;
  const skip = t3 === undefined ? false : t3;
  const isRefreshCache = useIsRefreshCache();
  const userLocation = useUserLocation();
  const zipCode = userLocation?.zip ?? "";
  const t4 = userLocation?.stateShortName;
  let t5;
  if ($[2] !== t4) {
    t5 = getVisitorLocationQueryVariables(t4);
    $[2] = t4;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== isRefreshCache || $[5] !== productIds || $[6] !== t5 || $[7] !== zipCode) {
    t6 = {
      productIds,
      refreshCache: isRefreshCache,
      limit: 12,
      zipCode,
      showSearchProductsOnly: true,
      ...t5
    };
    $[4] = isRefreshCache;
    $[5] = productIds;
    $[6] = t5;
    $[7] = zipCode;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== skip || $[10] !== t6) {
    t7 = {
      fetchPolicy: "cache-and-network",
      variables: t6,
      skip
    };
    $[9] = skip;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  const {
    data,
    loading
  } = useSuspenseQuery(GET_PRODUCTS_STATIC_DATA, t7);
  let t8;
  if ($[12] !== data?.getProductsStaticData?.products) {
    t8 = data?.getProductsStaticData?.products || [];
    $[12] = data?.getProductsStaticData?.products;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== data?.getProductsStaticData?.upholsteryOptions) {
    t9 = data?.getProductsStaticData?.upholsteryOptions || [];
    $[14] = data?.getProductsStaticData?.upholsteryOptions;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== loading || $[17] !== t8 || $[18] !== t9) {
    t10 = {
      products: t8,
      upholsteryOptions: t9,
      loading
    };
    $[16] = loading;
    $[17] = t8;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  return t10;
};
export default useStaticProductsData;